import { LineItemCardTypeTokens, } from '@voltmoney/schema';
export const args = {
    data: [
        {
            id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
            title: 'Total Cash Limit',
            amount: 30000,
        },
        {
            id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
            title: 'Processing Charge 1',
            amount: 56,
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d72',
            title: 'Processing Charge 2	',
            amount: 56,
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d72',
            title: 'Total Charges',
            amount: 76,
        },
    ],
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(LineItemCardTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
